import type React from "react";
import { isDateFilterValid, type PerformanceWithAccountFilter } from "../../Common/utils/performanceUtils";

interface EmptyStateWrapperProps {
  dateFilter: PerformanceWithAccountFilter | null;
  emptyState: React.ReactNode;
  children: React.ReactNode;
}

export const EmptyStateWrapper: React.FC<EmptyStateWrapperProps> = ({ dateFilter, emptyState, children }) =>
  isDateFilterValid(dateFilter) ? children : emptyState;
